import {alpha, Components} from '@mui/material';

import {Colors} from '@constants/colors.constants';
import {Sizes} from '@constants/sizes.constants';

const appBar: Components = {
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: Colors.white,
        border: `1px solid ${alpha('#B9BBC1', 0.3)}`,
        boxShadow: 'none',
        marginLeft: Sizes.leftBar,
        width: `calc(100% - ${Sizes.leftBar}px)`,
      },
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        alignItems: 'center',
        color: Colors.black,
        display: 'flex',
        height: Sizes.topBar,
        justifyContent: 'flex-end',
        minHeight: `${Sizes.topBar}px !important`,
        padding: '0 20px 0 0 !important',
      },
    },
  },
};

export default appBar;
